// Versão do aplicativo GoldSafe
export const APP_VERSION = '2.102';
